"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (candles) {
    return candles.map(function (data) {
        return { quote: +data.open, epoch: +data.epoch };
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/ohlcToTicks.js
// module id = 120
// module chunks = 0